
export enum GoalMode {
  STUDENT_RECRUITMENT = 'Student Recruitment',
  TALENT_PIPELINE = 'Hiring / Talent',
  RESEARCH_VISIBILITY = 'Research Visibility',
  SPONSOR_CREDIBILITY = 'Sponsor Credibility',
  COMMUNITY_AWARENESS = 'Community Awareness'
}

export enum AudienceType {
  PROSPECTIVE_STUDENTS = 'Prospective Students',
  GRADUATE_APPLICANTS = 'Graduate Applicants',
  RESEARCH_COLLABORATORS = 'Researchers/Collaborators',
  JOB_CANDIDATES = 'Job Candidates',
  SPONSORS_MEDIA = 'Sponsors/Media'
}

export type ContentType = 'page' | 'news' | 'post' | 'video';
export type FunnelStage = 'awareness' | 'consideration' | 'decision';
export type Platform = 'LinkedIn' | 'Instagram' | 'YouTube' | 'X';

export interface ConnectionConfig {
  apiKey?: string;
  projectId?: string;
  webhookUrl?: string;
  databaseUrl?: string;
  serviceAccountJson?: string;
  configJson?: string;
  connected: boolean;
}

export interface ConnectionStatus {
  ga4: ConnectionConfig;
  searchConsole: ConnectionConfig;
  zapier: ConnectionConfig;
  ur_database: ConnectionConfig;
}

export interface User {
  name: string;
  email: string;
  avatar?: string;
  role: string;
}

export interface Environment {
  id: string;
  name: string;
  isSample: boolean;
  connections: ConnectionStatus;
}

export interface ContentItem {
  id: string;
  title: string;
  url: string;
  type: ContentType;
  publish_date: string;
  topic_tags: string[];
  audience_tags: AudienceType[];
  funnel_stage: FunnelStage;
  owner: string;
}

export type InsightDecision = 'double_down' | 'fix_expand' | 'deprioritize' | 'none';

export interface Insight {
  id: string;
  type: 'winning_format' | 'underperforming_topic' | 'search_opportunity' | 'broken_funnel' | 'seasonal_opportunity';
  title: string;
  description: string;
  evidence: {
    query?: string;
    delta?: string;
    trend: 'rising' | 'flat' | 'declining';
    source: string;
  };
  confidence_score: number;
  recommended_actions: string[];
  decision: InsightDecision;
}

export interface AcademicEvent {
  id: string;
  title: string;
  date: string;
  type: 'deadline' | 'conference' | 'event';
  impact: 'high' | 'medium' | 'low';
}

/** Added Campaign and Task interfaces to fix import errors in mockData.ts */
export interface Campaign {
  id: string;
  name: string;
  objective: string;
  audience: string;
  start_date: string;
  end_date: string;
  channels: Platform[];
  landing_pages: string[];
  utm_schema: {
    source: string;
    medium: string;
    campaign: string;
  };
  kpi_targets: Record<string, number>;
  owner: string;
}

export interface Task {
  id: string;
  title: string;
  description: string;
  assignee: string;
  due_date: string;
  status: 'todo' | 'in_progress' | 'completed';
}
